import React from 'react';
import './Card.css';
import FavoriteBorder from '@mui/icons-material/FavoriteBorder';
import Favorite from '@mui/icons-material/Favorite';
import { Link } from 'react-router-dom';
import Checkbox from '@mui/material/Checkbox';

const label = { inputProps: { 'aria-label': 'Checkbox demo' } };
const Card = ({ item, viewStatus , type}) => {
    return (
        <div className='single-card'>

            <div className="card border-0">
                <img src={item.url}

                    className={
                        `
                                                                    ${viewStatus === 'list' ? 'card-img-top list-img' : 'card-img-top  card-img-categories '}
                                                                    `
                    } alt="..." />
                <Checkbox className="favouriteIcon" {...label} icon={<FavoriteBorder />} checkedIcon={<Favorite />} />
            </div>
            <Link to={`/singleProduct/${type}/${item.uniqueId}`}>
                <div className="card-body p-2">
                    <h6 className="card-title product-title" style={{ fontWeight: '800' }}>
                        {`${item.name} - ${item.quantity}`}</h6>
                    <h6 className="card-title" style={{ fontWeight: '800' }}>৳{item.price}</h6>
                </div>
            </Link>
        </div>
    );
};

export default Card;